
<div class="alert-message">
  <div class="lay_alert">
    <div v-show="showText" class="org_alert">
      <div class="m_slert_icon">
        <i class="fa fa-check-circle" aria-hidden="true"></i>
      </div>
      <div class="m_alert">
        <div class="a_alert" :title="title">{{ title }}</div>
      </div>
      <div class="close" @click="close"><i class="fa fa-times" aria-hidden="true"></i></div>
    </div>
  </div>
</div>
